import React from 'react';
import { Link } from 'react-router-dom';

// Primary "Get started" CTA — goes to app.rentid.io/sign-up.
const BookDemoButton = () => (
  <Link
    to="https://app.rentid.io/sign-up"
    className="vipo-btn vipo-btn--primary"
  >
    Get Started
  </Link>
);

export default BookDemoButton;
